"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPaymentAppCreateLink = void 0;
const constants_1 = require("../constants");
const buildPaymentAppCreateLink = (orderBackofficeId, businessUnit) => `${constants_1.PAYMENT_APP_URL}/criar-link/${orderBackofficeId}?bu=${businessUnit}`;
exports.buildPaymentAppCreateLink = buildPaymentAppCreateLink;
